export default __webpack_public_path__ + "static/media/complainIcon2.0ef459c5.webp";